import colors from 'src/styles/theme/colors'
import styled from 'styled-components'

export const ContainerStyle = styled.div`
  padding: 0;
  min-height: 40vh;
  background: ${colors.containerBackground};
`
